import { LoginState } from '../models/LoginState';
import * as React from 'react';

export class Home extends React.Component<any,any>{

    render(){
        return <h4> Hi, welcome to minbin a simple pastebin. Please login to get started!</h4>
    }
}


// WEBPACK FOOTER //
// ./src/components/Home.tsx